import { render, staticRenderFns } from "./TeNavFrame.vue?vue&type=template&id=d3740aa0&"
import script from "./TeNavFrame.vue?vue&type=script&lang=ts&"
export * from "./TeNavFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports